export * from './pagamentos-detalhes/pagamentos-detalhes.module';
export * from './pagamentos-listagem/pagamentos-listagem.module';
